import {camelToDashes} from 'rlink-utils/string';
import {StructuredDataContent} from 'rlink-repos/content';

export class Indexer extends StructuredDataContent {
  itemData (content) {
    return content.data;
  }

  pathMatchesItem (path, item) {
    return path === item.get('path');
  }

  findContentByPath (path) {
    return this.items.findEntry(
      (item) => this.pathMatchesItem(path, item))
  }

  findItemBy (keyPath, value) {
    return this.items.find((item) => item.getIn(keyPath) === value );
  }

  async fetchFullItemBy (repo, keyPath, value) {
    return await repo.fetchContentAtPath(
      this.findItemBy(keyPath, value).get('path'));
  }

  static async fetchFullItemBy (repo, keyPath, value) {
    return await (await this.get(repo)).fetchFullItemBy(repo, keyPath, value);
  }

  get items () {
    return this.data.get('items');
  }

  static appliesTo(contentClassName) {
    return contentClassName === this.contentClassName
  }

  static async index (command, repo) {

    if (command.constructor.isContentCommand) {
      let indexer = await this.get(repo);
       // Not our beeswax
      if (!this.appliesTo(command.contentClassName)) return null;


      let found = indexer.findContentByPath(command.contentPath);

      let updatedIndex;
      if (command.name === 'DeleteContent') {
        if (found) {
          let [itemIndex, value] = found;
          return indexer.removeValue('items', itemIndex);
        } else {
          return indexer;
        }

      } else {
        // any change other than deleting we treat pretty much the same:

        let content = await repo.fetchContentAtPath(command.contentPath)

        let itemData = (await indexer.itemData(content, repo)).set('path', content.path);

        if (found) {
          let [itemIndex, value] = found;
          updatedIndex = indexer.change('items', itemIndex, itemData);
        } else {
          updatedIndex = indexer.appendTo('items', itemData);
        }

        if ('sortKey' in indexer) {
          return updatedIndex.sortValues('items', indexer.sortKey);
        } else {
          return updatedIndex;
        }
      }
    } else {
      throw new Error("Don't know how to index non-ContentCommands");
    }
  }


  // we are all singletons
  static get (repo) {
    let registry = repo.contentRegistry;
    if (registry.hasClassNamed(this.name)) {
      let existing = registry.loadClassNamed(this.name);
      if (existing.indexFileName !== this.indexFileName) {
        throw new Error(`Can't register indexer ${this.name} because it is already registered by ${existing}`);
      }
    }
    repo.contentRegistry.registerClass(this.name, this, true);


    return this.fetchOrMakeFromPath(repo, this.indexFileName, {
      items: []
    });
  }

  static get indexFileName () {
    return '/generated/indexes/' + camelToDashes(this.name).replace(/-indexer$/, '') + '.json';
  }
}



// WEBPACK FOOTER //
// ./lib/rlink-cms/indexing/indexer.js